<ul>
  @if (employee.totalActionsRequired() > 0) {
    <li>
      <a
        matRipple
        class="menu-link-alert menu-link-alert--danger"
        role="button"
        tabindex="0"
        (click)="openPendingSlackChats($event)"
        (keydown.enter)="openPendingSlackChats($event)"
      >
        <mat-icon>notifications</mat-icon>
        <span
          >{{ employee.totalActionsRequired() }}
          {{ employee.totalActionsRequired() === 1 ? 'acción pendiente' : 'acciones pendientes' }}</span
        >
      </a>
    </li>
  }
  @if (canSeeProjects()) {
    @for (company_product_item of company_products_list(); track company_product_item.company_product_id; let first = $first) {
      <li [class.menu-first-section-item]="first" [class.active]="isCompanyProductActive(company_product_item.company_product_id)">
        <a
          matRipple
          role="button"
          tabindex="0"
          (click)="goToCompanyProduct(company_product_item.company_product_id)"
          (keydown.enter)="goToCompanyProduct(company_product_item.company_product_id)"
        >
          <div
            class="company-product-logo"
            [ngStyle]="{ 'background-image': 'url(' + company_product_item.company_product_logo_url + ')' }"
          ></div>
          <span>{{ company_product_item.company_product_name }}</span>
        </a>
      </li>
    }
  }

  <li routerLinkActive="active">
    <a matRipple [routerLink]="['/partners', 'my-company']">
      <mat-icon>business</mat-icon>
      <span>Mi empresa</span>
    </a>
  </li>

  @if (permissions.isDepartment('direction') || permissions.isDepartment('marketing')) {
    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive('marketing')"
      [attr.aria-expanded]="isExpanded('marketing')"
      (click)="toggle('marketing')"
      (keydown)="onSectionKeydown($event, 'marketing')"
    >
      <span class="menu-accordion-title">Marketing</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isExpanded('marketing')">expand_more</mat-icon>
    </li>
    @if (isExpanded('marketing')) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'marketing', 'blogposts']">
          <mat-icon>rss_feed</mat-icon>
          <span>Blog</span>
        </a>
      </li>
    }
  }

  @if (permissions.isDepartment('direction') || permissions.isDepartment('support')) {
    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive('support')"
      [attr.aria-expanded]="isExpanded('support')"
      (click)="toggle('support')"
      (keydown)="onSectionKeydown($event, 'support')"
    >
      <span class="menu-accordion-title">Soporte</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isExpanded('support')">expand_more</mat-icon>
    </li>
    @if (isExpanded('support')) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'support', 'tickets']">
          <mat-icon>support_agent</mat-icon>
          <span>Tickets</span>
        </a>
      </li>
    }
  }

  @if (permissions.isDepartment('direction') || permissions.isDepartment('rrhh')) {
    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive('rrhh')"
      [attr.aria-expanded]="isExpanded('rrhh')"
      (click)="toggle('rrhh')"
      (keydown)="onSectionKeydown($event, 'rrhh')"
    >
      <span class="menu-accordion-title">RRHH</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isExpanded('rrhh')">expand_more</mat-icon>
    </li>
    @if (isExpanded('rrhh')) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'workers']">
          <mat-icon>group</mat-icon>
          <span>Trabajadores</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'absences-management']">
          <mat-icon>flight_takeoff</mat-icon>
          <span>Gestión de ausencias</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'clock-register-review-requests']">
          <mat-icon>timer</mat-icon>
          <span>Gestión de fichajes</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'working-contract-weekly-schedule-exception-requests']">
          <mat-icon>edit_calendar</mat-icon>
          <span>Cambios de horario</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'working-extra-hours-periods']">
          <mat-icon>more_time</mat-icon>
          <span>Horas extras</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'remote-work-management']">
          <mat-icon>add_home_work</mat-icon>
          <span>Gestión de teletrabajo</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'payrolls']">
          <mat-icon>request_quote</mat-icon>
          <span>Nóminas</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'departments']">
          <mat-icon>supervised_user_circle</mat-icon>
          <span>Departamentos</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'holidays']">
          <mat-icon>event_upcoming</mat-icon>
          <span>Festividades</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'computers']">
          <mat-icon>computer</mat-icon>
          <span>Ordenadores</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'learning-resource-requests']">
          <mat-icon>school</mat-icon>
          <span>Solicitudes de formación</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'formations']">
          <mat-icon>menu_book</mat-icon>
          <span>Formaciones</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'job-vacancies']">
          <mat-icon>work</mat-icon>
          <span>Vacantes</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'exam-instances']">
          <mat-icon>quiz</mat-icon>
          <span>Exámenes</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'skills']">
          <mat-icon>psychology</mat-icon>
          <span>Skills</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'rrhh', 'document-types']">
          <mat-icon>description</mat-icon>
          <span>Tipos de documentos</span>
        </a>
      </li>
    }
  }

  @if (permissions.isDepartment('direction') || permissions.isDepartment('comercial')) {
    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive('comercial')"
      [attr.aria-expanded]="isExpanded('comercial')"
      (click)="toggle('comercial')"
      (keydown)="onSectionKeydown($event, 'comercial')"
    >
      <span class="menu-accordion-title">Comercial</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isExpanded('comercial')">expand_more</mat-icon>
    </li>
    @if (isExpanded('comercial')) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'comercial', 'dashboard']">
          <mat-icon>insights</mat-icon>
          <span>Dashboard & KPIs</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'comercial', 'lead-assignment']">
          <mat-icon>percent</mat-icon>
          <span>Asignación leads Meta</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'comercial', 'potential-clients']">
          <mat-icon>emoji_people</mat-icon>
          <span>Clientes potenciales</span>
        </a>
      </li>
    }
  }

  @if (permissions.isDepartment('direction')) {
    <li
      class="menu-separator menu-accordion-header"
      matRipple
      role="button"
      tabindex="0"
      [class.section-active]="isSectionActive('direction')"
      [attr.aria-expanded]="isExpanded('direction')"
      (click)="toggle('direction')"
      (keydown)="onSectionKeydown($event, 'direction')"
    >
      <span class="menu-accordion-title">Dirección</span>
      <mat-icon class="menu-accordion-chevron" [class.expanded]="isExpanded('direction')">expand_more</mat-icon>
    </li>
    @if (isExpanded('direction')) {
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'company-products']">
          <mat-icon>apps</mat-icon>
          <span>Gestión de productos</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'users']">
          <mat-icon>manage_accounts</mat-icon>
          <span>Usuarios</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'companies']">
          <mat-icon>business</mat-icon>
          <span>Clientes</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'providers']">
          <mat-icon>local_shipping</mat-icon>
          <span>Proveedores</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'company-product-monthly-economic-reports']">
          <mat-icon>receipt_long</mat-icon>
          <span>Facturas de productos</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'configuration']">
          <mat-icon>settings</mat-icon>
          <span>Configuración</span>
        </a>
      </li>
      <li routerLinkActive="active">
        <a matRipple [routerLink]="['/partners', 'direction', 'legal']">
          <mat-icon>policy</mat-icon>
          <span>Documentación legal</span>
        </a>
      </li>
    }
  }
</ul>
